import { render, staticRenderFns } from "./ChallengeRoom.vue?vue&type=template&id=00ada500&scoped=true"
import script from "./ChallengeRoom.vue?vue&type=script&lang=js"
export * from "./ChallengeRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ada500",
  null
  
)

export default component.exports